import type { FooterLinkElementViewModel } from 'autogen/swagger/all';
import React from 'react';
import { handleClickTracking } from '../shared/tracking';
import InlinePageActionButton from 'components/generic/InlineButton/InlinePageActionButton';

export default function ReadMoreLink(props: FooterLinkElementViewModel): JSX.Element {
    const { pageAction, text, datalayer, ...restProps } = props;

    return (
        <InlinePageActionButton
            action={pageAction}
            variant="dark"
            fontWeight="semibold"
            size={{ xs: 'sm', xl: 'lg' }}
            onClick={() => handleClickTracking(text)}
            data-datalayer={JSON.stringify(datalayer)}
            {...restProps}
        >
            {text}
        </InlinePageActionButton>
    );
}
